import { GraphQLResult } from "@aws-amplify/api";
import { API } from "aws-amplify";
import { Dispatch,SetStateAction } from "react";
import { toast } from 'react-toastify';

import { listNutrients } from "../../../graphql/queries";
import { updateLoading } from "../../../redux/slice/appSlice";
import { AppDispatch } from "../../../redux/store";
import { ListNutrientsQuery, Nutrient } from "../../../types/api";

interface getNutrientDetailListProp {
  dispatch: AppDispatch;
  updateNutrients: Dispatch<SetStateAction<(Nutrient|null)[]>>;
}
export const getNutrientDetailList: ({
  dispatch,
  updateNutrients
}: getNutrientDetailListProp) => Promise<void> = async ({
  dispatch,
  updateNutrients
}: getNutrientDetailListProp) => {
  try {
    dispatch(updateLoading(true));
    const getResponse: GraphQLResult<ListNutrientsQuery> = await API.graphql({
      query: listNutrients
    }) as GraphQLResult<ListNutrientsQuery>;
    if (getResponse.data?.listNutrients?.items) {
        updateNutrients(getResponse.data.listNutrients.items);
    }
  } catch (err) {
    // console.log(err)
    toast.dark("Error: Get Nutrient List.");
  } finally {
    dispatch(updateLoading(false));
  }
};
